import { useState } from "react";
import axios from "../axios";
import { toast } from "react-toastify";

const FileUploader = ({
    uploadUrl,
    allowedTypes = ["image", "audio", "video"], // default allowed types
    userId,
    categoryId,
    useCase,
    onUploadSuccess, // callback to parent
}) => {
    const [uploadProgress, setUploadProgress] = useState(0);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate file type
        const isValid = allowedTypes.some((type) => file.type.startsWith(type + "/"));
        if (!isValid) {
            toast.error(`Only ${allowedTypes.join(", ")} files are allowed`);
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        if (useCase == "extract-text") {
            if (useCase) formData.append("useCase", useCase);
        }
        else {
            if (userId) formData.append("userId", userId);
            if (categoryId) formData.append("categoryId", categoryId);
        }

        const headers = {
            Authorization: "Bearer " + localStorage.getItem("@token"),
            "Content-Type": "multipart/form-data",
        };

        try {
            toast.info("Uploading file...");

            const res = await axios.post(uploadUrl, formData, {
                headers,
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percent);
                },
            });

            toast.success("File uploaded successfully!");
            setUploadProgress(0);


            if (onUploadSuccess) {
                onUploadSuccess(useCase === "extract-text" ? res.data.text : res.data.fileUrl);
            }

        } catch (err) {
            setUploadProgress(0);
            const errorMsg =
                err.response?.data?.error || err.message;
            toast.error("Failed to upload file: " + errorMsg);
            console.error("File upload failed:", err);
        }
    };

    return (
        <div>
            <input type="file" onChange={handleFileChange} className="mt-2" />
            {uploadProgress > 0 && (
                <div className="mt-2 w-full bg-gray-200 rounded h-4">
                    <div
                        className="bg-blue-500 h-4 text-white text-center text-xs rounded"
                        style={{ width: `${uploadProgress}%` }}
                    >
                        {uploadProgress}%
                    </div>
                </div>
            )}
        </div>
    );
};

export default FileUploader;